import { render, staticRenderFns } from "./pi-segments.vue?vue&type=template&id=deb493f6&scoped=true&"
import script from "./pi-segments.vue?vue&type=script&lang=ts&"
export * from "./pi-segments.vue?vue&type=script&lang=ts&"
import style0 from "./pi-segments.vue?vue&type=style&index=0&id=deb493f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb493f6",
  null
  
)

export default component.exports